<template>
  <div class="sidenavright-menu fullheight">
    <div class="sidenavright-content">
      <div class="pill" v-click-outside="closeMenu">
        <div class="pill-header">
          <div class="row no-margin">
            <div class="col no-padding">
              <div class="pill-title">
                {{walletDetail.indent_id}}
              </div>
            </div>
            <div class="col-md-auto no-padding bgclose">
              <div class="close-sidebar">
                <svgicon name="cancelwhite" width="14" height="14"
                  :original="true" @click="closeMenu" />
              </div>
            </div>
          </div>
        </div>
        <div class="pill-body">
          <div class="pill-row mt-10">
            <Table
              :data="getConsigneeTransitDelay"
              :stripe="true"
              class="table-striped bordered"
              aria-describedby="getConsigneeTransitDelay"
              >
              <table-column
                prop="consignee_name"
                label="Consignee">
              </table-column>
              <table-column
                prop="transit_days"
                label="Transit Days">
              </table-column>
              <table-column
                prop="amount"
                label="Amount">
              </table-column>
            </Table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['walletDetail'],
  computed: {
    getConsigneeTransitDelay() {
      const walletDetails = this.walletDetail.consignee_data.filter(consignee => consignee.transitDelay);
      return walletDetails.map(consignee => {
        return {
          consignee_name: consignee.name,
          transit_days: consignee.transitDelay.days,
          amount: consignee.transitDelay.amount,
        }
      });
    },
  },
  methods: {
    closeMenu() {
      this.$emit('close');
    },
  },
};
</script>
